<div class="conteudo ml-2 mr-2">
  <div class="row caixa-filtros shadow-sm">
    <div class="col-4">
      <div translate class="filtro ng-star-inserted sm-font" style="margin: 0px 10px 0px 0px;">
        {{'businessIntelligence.SPUIO.dataReferencia'}}
      </div>
      <div class="input-group input-group-sm data-fixo">
        <input class="form-control" class="form-control" placeholder="Selecio a Data de Referência" readonly
          [maxDate]="max" ngbDatepicker #dataInicialView="ngbDatepicker" [(ngModel)]="InicialData"
          [(ngModel)]="dataInicial" (click)="dataInicialView.toggle()">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button">
            <em class="fa fa-calendar"></em>
          </button>
        </div>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="buscar()" type="button">
            <em class="fas fa-search"></em>
          </button>
        </div>
      </div>
    </div>
    <div class="col-8">
      <app-barra-consulta *ngIf="!carregando" visible="false" (atualizando)="atualizar($event)"
        (inserindo)="novo($event)" [exibirNovo]="false" [detalhe]="detalhe" [exibirBotaoDefinirFiltros]="false"
        [exibirBarraCor]="false" [exibirBotaoBuscar]="false" [exibirBotaoBuscar]="false">
      </app-barra-consulta>
    </div>
  </div>
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="mt-3">
      <div class="row">
        <div class="col">
          <h5 class="ml-3" translate>{{'businessIntelligence.SPUIO.tituloGrid'}}</h5>
        </div>
        <div class="col">
          <button class="btn btn-outline-secondary btn-sm mb-1 mr-3 float-right" (click)="exportarExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export Excel
          </button>

          <button translate class="btn btn-outline-secondary btn-sm mb-2 mr-1 float-right" (click)="imprimePdf()">
            <em class="fa fa-download fa-xs"></em>
            {{'businessIntelligence.SPUIO.btnImprimir'}}
          </button>
        </div>
      </div>
    </div>
    <div id="print-section">
      <div class="container-fluid">
        <div class="content">
          <div class="legendas-caption pb-2">
            <div class="row ml-2 pt-2 pb-2">
              <div class="maior ml-2 mt-2"></div>
              <p translate class="font-sm text-muted mt-2 ml-2">
                % >
                <ng-container>
                  {{'businessIntelligence.SPUIO.brasil'}}
                </ng-container>
              </p>
              <div class="menor ml-4 mt-2"></div>
              <p translate class="font-sm text-muted mt-2 ml-2">
                % < <ng-container>
                  {{'businessIntelligence.SPUIO.brasil'}}
                  </ng-container>
              </p>
            </div>
          </div>          
          <table class="table table-striped table-hover table-sm" id="excel-table">
            <thead class="thead-dark">
              <tr>
                <th [appSort]="spuioDados" data-order="asc" data-name="codigo_dealer" class="text-center sort-click"
                  rowspan="2">
                  Dealer
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="nome_dealer" translate
                  class="text-center sort-click" rowspan="2">
                  {{'businessIntelligence.SPUIO.nome'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th translate class="text-center" colspan="3">
                  {{'businessIntelligence.SPUIO.vendaMotos'}}
                </th>
                <th translate class="text-center" colspan="3">
                  {{'businessIntelligence.SPUIO.vendaPecas'}}
                </th>
                <th class="text-center" colspan="4">
                  SPUIO
                </th>
                <th translate>
                  {{'businessIntelligence.SPUIO.oportunidade'}}
                </th>
              </tr>
              <tr>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_anterior_motos" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_atual_motos" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="percentual_motos" class="text-center sort-click">
                  %
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_anterior_pecas" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_atual_pecas" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="percentual_pecas" class="text-center sort-click">
                  %
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_anterior_spuio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="ano_atual_spuio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="crescimento_spuio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.crescimento'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="percentual_spuio" class="text-center sort-click">
                  %
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="spuioDados" data-order="asc" data-name="venda_oportunidade" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.SPUIO.venda'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr-body" *ngFor="let dados of spuioDados"
                [ngStyle]="{backgroundColor:getColor(dados, percentual_spuio)}">
                <td>{{dados.codigo_dealer}}</td>
                <td>{{dados.nome_dealer}}</td>
                <td>{{dados.ano_anterior_motos}}</td>
                <td>{{dados.ano_atual_motos}}</td>
                <td>{{dados.percentual_motos | percent: '1.0-0'}}</td>
                <td>{{dados.ano_anterior_pecas | currency: ' '}}</td>
                <td>{{dados.ano_atual_pecas | currency: ' '}}</td>
                <td>{{dados.percentual_pecas | percent: '1.0-0'}}</td>
                <td>{{dados.ano_anterior_spuio | currency: ' '}}</td>
                <td>{{dados.ano_atual_spuio | currency: ' '}}</td>
                <td>{{dados.crescimento_spuio | currency: ' '}}</td>
                <td>{{dados.percentual_spuio | percent: '1.0-0'}}</td>
                <td>{{dados.venda_oportunidade | currency: ' '}}</td>
              </tr>
              <tr class="tr-footer">
                <td></td>
                <td [translate]="getTranslate(this.nome_dealer)"></td>
                <td>{{ano_anterior_motos}}</td>
                <td>{{ano_atual_motos}}</td>
                <td>{{percentual_motos | percent: '1.0-0'}}</td>
                <td>{{ano_anterior_pecas | currency: ' '}}</td>
                <td>{{ano_atual_pecas | currency: ' '}}</td>
                <td>{{percentual_pecas | percent: '1.0-0'}}</td>
                <td>{{ano_anterior_spuio | currency: ' '}}</td>
                <td>{{ano_atual_spuio | currency: ' '}}</td>
                <td>{{crescimento_spuio | currency: ' '}}</td>
                <td>{{percentual_spuio | percent: '1.0-0'}}</td>
                <td>{{venda_oportunidade | currency: ' '}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
